import queryString from "app/services/queryStringService";
import { memo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import { Breadcrumb } from "@gull";
import {
  addUpdateAirlines,
  getVendorFareList,
} from "app/services/vendorService";
import { Button, Col, Form, Image, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { MdAddBox, MdSearch } from "react-icons/md";
import Tooltip from "rc-tooltip";
import moment from "moment";
import Swal from "sweetalert2";

import { NotificationManager } from "react-notifications";
import SupplierAirlinesAddUpdate from "./Components/SupplierAirlinesAddUpdate";
import { GrDocumentUpdate } from "react-icons/gr";
import { FaEdit } from "react-icons/fa";
import { getUserGroup } from "app/services/userGroupService";
import { RenderSelectInput } from "app/common/renderInput";

const SupplierAirlinesList = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [userSearch, setUserSearch] = useState("");
  const [userGroupId, setUserGroupId] = useState(0);
  const [show, setShow] = useState(false);
  const [initialValues, setInitialValues] = useState({
    mode: "ADD",
    supplierId: 0,
    carrierIdList: [],
    status: true,
    userGroupId: 0,
    applyToAllUserGroups: false,
  });
  const [userGroupDetails, setUserGroupDetails] = useState(null);
  const [edit, setEdit] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const editHandler = () => {
    setEdit(true);
    handleShow();
  };
  const userHandler = async () => {
    const userDetails = await getUserGroup();
    setUserGroupDetails(
      userDetails.data.data.map((item) => {
        return { value: item.id, label: item.name };
      })
    );
    setUserGroupId(userDetails.data.data[0].id);
  };
  const carrierInfo = (cell, row) => {
    // console.log(dateTimeFormat);
    return (
      <div>
        <Image
          src={`/assets/images/airlineLogo/${row.flightCarrier.flightcarrierCode}.gif`}
          alt=""
          height="20"
          width={"20"}
          style={{ marginRight: 3, borderRadius: 15 }}
        />
        {row.flightCarrier.flightCarrierName}
      </div>
    );
  };
  const dateFormatter = (cell, row) => {
    // console.log(dateTimeFormat);
    return cell ? (
      <div>
        <div>{moment(cell).format("DD-MM-YYYY")}</div>
        <div>{moment(cell).format("HH:mm a")}</div>
      </div>
    ) : (
      "-"
    );
  };
  const updateDefaultApi = async (row) => {
    Swal.fire({
      title: ` Are you sure you want to ${
        row.status == true ? "deactivate " : "activate"
      } the Supplier Airlines?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.value) {
        let data = {
          mode: "EDIT",
          supplierId: row?.supplierId,
          carrierIdList: [row?.carrierId],
          status: !row?.status,
          userGroupId: Number(userGroupId),
        };

        try {
          const response = await addUpdateAirlines(data);
          if (response.status == "Success") {
            NotificationManager.success(response.message);
          } else {
            NotificationManager.error("Something Went to be Wrong");
          }
        } catch (error) {
          NotificationManager.error("Something Went to be Wrong");
        }

        loadAirlines();
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",
          type: "error",
          icon: "error",
          timer: 1500,
        });
      }
    });
  };
  const statusFormatter = (cell, row) => {
    return (
      <div className="row align-items-center d-flex justify-content-center">
        <div className="col-auto text-red">
          <span
            style={{
              color: row.status == false && "red",
            }}
          >
            Deactivate
          </span>
        </div>
        <div className="col-auto">
          <div
            className="d-flex justify-content-center"
            // style={{ cursor: "pointer" }}
          >
            <Tooltip
              placement="top"
              overlay={
                row.status === false
                  ? "Click to activate"
                  : "Click to deactivate"
              }
            >
              <span>
                <Form.Check
                  type="switch"
                  id={`custom-switch${row.id}`}
                  checked={row.status}
                  onChange={() => updateDefaultApi(row)}
                />
              </span>
            </Tooltip>
          </div>
        </div>
        <div className="col-auto">
          <div
            style={{
              color: row.status !== false ? "green" : "inherit",
            }}
          >
            Activate
          </div>
        </div>
      </div>
    );
  };
  const columns = [
    {
      dataField: "createDate",
      text: "Created On",
      headerStyle: (column, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "modifyDate",
      text: "Modified On",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: dateFormatter,
    },
    {
      dataField: "supplierName",
      text: "Supplier Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      // formatter: vendorName,
    },
    {
      dataField: "carrierId",
      text: "Carrier Info",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: carrierInfo,
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center" };
      },
      formatter: statusFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadAirlines = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      searchText: userSearch,
      userGroupId,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await getVendorFareList(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };
  useEffect(() => {
    userHandler();
  }, []);

  useEffect(() => {
    if (userGroupId) {
      loadAirlines();
    }
  }, [page, sizePerPage, userSearch, userGroupId]);
  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    // setTimeout(async () => {
    //   await loadAirlines();
    // }, 10);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "userSearch":
        setUserSearch(value);
        break;
      case "userGroupId":
        setUserGroupId(value);
        break;

      default:
        break;
    }
  };
  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setTimeout(async () => {
      await loadAirlines();
    }, 10);
  };

  const refreshFilter = async (e) => {
    setUserSearch("");
    setUserGroupId(0);
    setTimeout(async () => {
      await loadAirlines();
    }, 10);
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size </label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Supplier Airlines List</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Supplier Airlines List" }]}
      ></Breadcrumb>
      <Row className="mb-2">
        <Col
          lg={12}
          xs={12}
          style={{
            justifyContent: "flex-end",
            display: "flex",
          }}
        >
          <button
            className="btn btn-outline-primary me-2"
            onClick={editHandler}
          >
            <FaEdit size={20} />
            Bulk Update
          </button>
          <Button className="btn-md" variant="primary" onClick={handleShow}>
            <MdAddBox size={20} />
            Bulk Add
          </Button>
        </Col>
      </Row>

      <div className="card card-body mb-3 ">
        <Row className="mb-2">
          <Col lg={5} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <label className="pb-1">Search</label>
            <div>
              <input
                type="text"
                className="form-control"
                name="userSearch"
                value={userSearch}
                placeholder="Search"
                onChange={handleSearchChanges}
              />
            </div>
          </Col>
          <Col lg={5} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <label className="pb-1">User Group</label>
            <div>
              <select
                className="form-select"
                name="userGroupId"
                placeholder="User Group"
                value={userGroupId}
                onChange={handleSearchChanges}
              >
                {userGroupDetails?.map((item) => (
                  <option key={item.id} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </Col>

          <Col lg={2} xs={12}>
            {/* Full width on extra small screens, half on large screens */}
            <div className="d-flex justify-content-end pt-4">
              <button
                className="btn btn-outline-primary d-flex align-items-center"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>

              <button
                className="btn btn-outline-primary d-flex align-items-center ms-3"
                onClick={refreshFilter}
              >
                Refresh
              </button>
            </div>
          </Col>
        </Row>

        <div style={{ overflow: "auto" }}>
          <BootstrapTable
            hover
            remote
            keyField="uniqueIdentity"
            data={data}
            columns={columns}
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
          <SupplierAirlinesAddUpdate
            show={show}
            handleClose={handleClose}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
            loadAirlines={loadAirlines}
            edit={edit}
            setEdit={setEdit}
          />
        </div>
      </div>
    </>
  );
};

export default memo(SupplierAirlinesList);
